/*
 * Opens GoKwik's KwikCart side cart (app embed "gokwik-cart-slide-cart-drawer") after a
 * successful add to cart.
 *
 * Reuses Dawn's own flow instead of re-implementing it: <product-form> publishes
 * PUB_SUB_EVENTS.cartUpdate with source 'product-form' only after /cart/add succeeds
 * (errors publish cartError instead). No fetch/XHR interception and no second add-to-cart
 * path. Add-to-cart analytics come from Shopify's web pixels, so nothing is tracked here.
 *
 * Loaded from layout/theme.liquid because product forms (PDP, quick add on cards,
 * featured product) can appear on any template.
 */
(function () {
  'use strict';

  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  function openSideCart() {
    if (typeof window.openGokwikSideCart !== 'function') return;
    try {
      if (typeof window.refreshSideCart === 'function') window.refreshSideCart();
      window.openGokwikSideCart();
    } catch (error) {
      console.error('[cart] GoKwik side cart failed to open:', error);
    }
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    // Only adds: cart page / drawer quantity edits also publish cartUpdate.
    if (!event || (event.source !== 'product-form' && event.source !== 'bundle-add')) return;
    if (event.openCart === false) {
      if (typeof window.refreshSideCart === 'function') {
        try {
          window.refreshSideCart();
        } catch (error) {
          console.error('[cart] GoKwik side cart failed to refresh:', error);
        }
      }
      return;
    }
    // Without the app embed, Dawn's own cart drawer already rendered the response.
    if (typeof window.openGokwikSideCart !== 'function') return;

    // product-form.js keeps the quick-add modal open until the add resolves, then closes it.
    if (document.querySelector('quick-add-modal[open]')) {
      document.body.addEventListener('modalClosed', function () { setTimeout(openSideCart); }, { once: true });
      return;
    }
    openSideCart();
  });
})();
